import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { TruncatePipe } from './pipes/truncate.pipe';

@NgModule({
    declarations: [TruncatePipe],
    imports: [CommonModule, HttpClientModule, RouterModule],
    exports: [HttpClientModule, RouterModule, TruncatePipe],
})
export class CoreModule {}
